var _defs, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMarkerLab = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74.998,
    height: 109.616,
    viewBox: "0 0 74.998 109.616",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#64b246;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M438.154,1851.713a37.5,37.5,0,0,0-37.5,37.5c0,20.71,36.417,72.117,36.417,72.117s38.581-51.407,38.581-72.117A37.5,37.5,0,0,0,438.154,1851.713Zm14.7,56.758a5.048,5.048,0,0,1-4.54,2.529H427.474a5.106,5.106,0,0,1-4.541-2.529,5.23,5.23,0,0,1-.286-5.15L432,1890.25V1878h-.036a1.5,1.5,0,0,1,0-3h11.858a1.5,1.5,0,0,1,0,3H443v12.2l9.745,13.07A5.065,5.065,0,0,1,452.853,1908.471Z",
    transform: "translate(-400.655 -1851.713)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarkerLab, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/marker_lab.25ab0c25.svg";
export { ForwardRef as ReactComponent };